<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Feed Out</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <BTable :items="feedOuts" :fields="fields" :busy="isTableBusy">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(url)="data">
                <a target="_blank" :href="data.item.url">{{ data.item.url }}</a>
              </template>
              <template v-slot:cell(active)="data">
                <BFormCheckbox
                  switch
                  :checked="!data.item.disabled"
                  :disabled="isSpinning('toggle', data.item.id)"
                  @change="handleToggleFeed(data.index, data.item)"
                ></BFormCheckbox>
              </template>
              <template v-slot:cell(actions)="data">
                <BButton
                  class="fa"
                  v-bind:class="{
                    'fa-play': !isSpinning('run', data.item.id)
                  }"
                  size="sm"
                  variant="success"
                  :disabled="data.item.disabled || data.item.is_running || isSpinning('run', data.item.id)"
                  @click.prevent="handleRunFeed(data.index, data.item)"
                >
                  <BSpinner
                    class="spinner-border spinner-border-sm"
                    v-if="isSpinning('run', data.item.id)"
                    label="Spinning"
                  ></BSpinner>
                </BButton>
              </template>
            </BTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BTable, BButton, BSpinner, BFormCheckbox } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BButton,
    BSpinner,
    BFormCheckbox
  },
  data() {
    return {
      isTableBusy: true,
      feedOuts: [],
      disableButtons: false,
      spinningButton: {
        buttonType: null,
        requestId: null
      },
      fields: [
        "name",
        { key: "active", label: "active" },
        "is_running",
        "last_generation_status",
        "last_generation",
        "url",
        "actions"
      ]
    };
  },
  methods: {
    isSpinning(buttonType, id) {
      return (
        this.spinningButton.buttonType === buttonType &&
        this.spinningButton.requestId === id
      );
    },

    formatResponse(feedOut) {
      return feedOut;
    },

    handleRunFeed(index, { id, name }) {
      this.toggleButtonsState("run", id);
      this.$http
        .put(`/enroll_admin/feed-out/run/${name}`)
        .catch(error =>
          this.$bvToast.toast(error.response.data.error || error.response.data.message, {
            variant: "danger"
          })
        )
        .finally(() => {
          this.isTableBusy = false;
          this.toggleButtonsState("run", id);
        });
    },

    handleToggleFeed(index, { id, name }) {
      this.toggleButtonsState("toggle", id);
      this.$http
        .put(`/enroll_admin/feed-out/toggle/${name}`)
        .then(({ data }) => {
          this.$set(this.feedOuts, index, this.formatResponse(data));
        })
        .catch(error =>
          this.$bvToast.toast(error.response.data.error || error.response.data.message, {
            variant: "danger"
          })
        )
        .finally(() => {
          this.toggleButtonsState("toggle", id);
        });
    },

    toggleButtonsState(buttonType, companyId) {
      this.disableButtons = !this.disableButtons;
      if (this.spinningButton.buttonType === null) {
        this.spinningButton = {
          buttonType,
          requestId: companyId
        };
      } else {
        this.spinningButton = {
          buttonType: null,
          requestId: null
        };
      }
    }
  },
  created() {
    this.$http
      .get("/enroll_admin/feed-out")
      .then(({ data }) => {
        this.feedOuts = data.map(this.formatResponse);
      })
      .finally(() => (this.isTableBusy = false));
  }
};
</script>
